import script from "./FlyersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlyersView.vue?vue&type=script&setup=true&lang=ts"

import "./FlyersView.vue?vue&type=style&index=0&id=2ccf47c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ccf47c0"]])

export default __exports__